module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.year,
      "input-align": "right",
      "label": "申报时间",
      "placeholder": "点击选择年份"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu.length ? _vm.formData.extra_saiqu[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "领取的比赛或活动名称",
      "placeholder": "点击选择领取的比赛或活动名称"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "text": "四好运动员申报截止时间为比赛开始前10天"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("报名运动员" + _vm._s(_vm.sai_member_count) + "位,可报四好运动员" + _vm._s(_vm.member_limit) + "位")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "领取地址",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "label": "领取日期",
      "input-align": "right",
      "error-message-align": "right",
      "placeholder": "请选择领取日期",
      "rules": [{
        required: true,
        message: '请选择领取日期'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDate = true
      }
    },
    model: {
      value: (_vm.formData.getdate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "getdate", $$v)
      },
      expression: "formData.getdate"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "选择年月日",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "confirm": _vm.onDateConfirm,
      "cancel": function($event) {
        _vm.showDate = false
      }
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "领取单位",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '联系人名称不能为空'
      }],
      "label": "联系人",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入联系人名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "电话",
      "error": _vm.formValidate && !_vm.formData.phone,
      "type": "number",
      "placeholder": "电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("最多可选择" + _vm._s(_vm.member_limit) + "位四好运动员哦")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.member_limit > 0) ? _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.showYundongyuanPicker = true
      }
    }
  }, [_vm._v("选择运动员")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.formData.member_list), function(subject, index) {
    return _c('div', {
      key: index
    }, [_c('van-divider', [_vm._v("四好运动员信息" + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
      attrs: {
        "clearable": "",
        "input-align": "right",
        "error-message-align": "right",
        "label": "姓名",
        "placeholder": "请输入姓名",
        "rules": [{
          required: true,
          message: '请输入姓名'
        }]
      },
      model: {
        value: (subject.name),
        callback: function($$v) {
          _vm.$set(subject, "name", $$v)
        },
        expression: "subject.name"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "rules": [{
          required: true,
          message: '请输入证件号'
        }],
        "error-message-align": "right",
        "input-align": "right",
        "label": "证件号",
        "placeholder": "请输入证件号"
      },
      model: {
        value: (subject.num),
        callback: function($$v) {
          _vm.$set(subject, "num", $$v)
        },
        expression: "subject.num"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "input-align": "right",
        "label": "民族",
        "placeholder": "请输入民族"
      },
      model: {
        value: (subject.mingzu),
        callback: function($$v) {
          _vm.$set(subject, "mingzu", $$v)
        },
        expression: "subject.mingzu"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "input-align": "right",
        "label": "学段",
        "rules": [{
          required: true,
          message: '请输入学段'
        }],
        "placeholder": "请输入学段"
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function() {
          return [_c('van-radio-group', {
            model: {
              value: (_vm.formData.xueduan),
              callback: function($$v) {
                _vm.$set(_vm.formData, "xueduan", $$v)
              },
              expression: "formData.xueduan"
            }
          }, [_c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "幼儿园"
            }
          }, [_vm._v("幼儿园")]), _vm._v(" "), _c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "小学"
            }
          }, [_vm._v("小学")]), _vm._v(" "), _c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "初中"
            }
          }, [_vm._v("初中")]), _vm._v(" "), _c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "高中"
            }
          }, [_vm._v("高中")]), _vm._v(" "), _c('van-radio', {
            attrs: {
              "checked-color": "#ffb01b",
              "name": "大学"
            }
          }, [_vm._v("大学")])], 1)]
        },
        proxy: true
      }], null, true),
      model: {
        value: (subject.xueduan),
        callback: function($$v) {
          _vm.$set(subject, "xueduan", $$v)
        },
        expression: "subject.xueduan"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("以下得分每项满分20，队内自行评分提交即可。")]), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "type": "number",
        "input-align": "right",
        "label": "品德得分",
        "placeholder": "请输入品德得分"
      },
      model: {
        value: (subject.score_pingde),
        callback: function($$v) {
          _vm.$set(subject, "score_pingde", $$v)
        },
        expression: "subject.score_pingde"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "type": "number",
        "input-align": "right",
        "label": "学段得分",
        "placeholder": "请输入学段得分"
      },
      model: {
        value: (subject.score_xuexi),
        callback: function($$v) {
          _vm.$set(subject, "score_xuexi", $$v)
        },
        expression: "subject.score_xuexi"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "type": "number",
        "input-align": "right",
        "label": "气质得分",
        "placeholder": "请输入气质得分"
      },
      model: {
        value: (subject.score_qizhi),
        callback: function($$v) {
          _vm.$set(subject, "score_qizhi", $$v)
        },
        expression: "subject.score_qizhi"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "type": "number",
        "input-align": "right",
        "label": "技术得分",
        "placeholder": "请输入技术得分"
      },
      model: {
        value: (subject.score_jishu),
        callback: function($$v) {
          _vm.$set(subject, "score_jishu", $$v)
        },
        expression: "subject.score_jishu"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "clearable": "",
        "type": "number",
        "input-align": "right",
        "label": "投票得分",
        "placeholder": "请输入投票得分"
      },
      model: {
        value: (subject.score_toupiao),
        callback: function($$v) {
          _vm.$set(subject, "score_toupiao", $$v)
        },
        expression: "subject.score_toupiao"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "native-type": "button",
        "size": "normal",
        "round": "",
        "icon": "close"
      },
      on: {
        "click": function($event) {
          return _vm.memberRemove(subject, index)
        }
      }
    }, [_vm._v("删除运动员")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          提交申请\n        ")])], 1)], 1), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker,
      "limit": 1,
      "url": "api/sai/clubSaiquOptions",
      "is_online": 2,
      "start_date": _vm.now,
      "value": _vm.formData.extra_saiqu,
      "defaultValue": _vm.formData.extra_saiqu
    },
    on: {
      "onChange": _vm.onSaiquChange,
      "onClose": function($event) {
        _vm.showSaiquPicker = false
      },
      "onConfirm": _vm.onSaiquConfirm
    }
  }), _vm._v(" "), _c('YundongyuanPicker', {
    attrs: {
      "show": _vm.showYundongyuanPicker,
      "limit": _vm.member_limit,
      "list": _vm.sai_member_list,
      "defaultValue": _vm.formData.member_list
    },
    on: {
      "onChange": _vm.onYundongyuanChange,
      "onClose": function($event) {
        _vm.showYundongyuanPicker = false
      },
      "onConfirm": _vm.onYundongyuanConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad861d84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailSihaoApply.vue
// module id = 2565
// module chunks = 0